export const apiName: string = 'areas';
export const areasRoute: string = 'areas';
export const areasStorage: string = 'areas';
export const areasModuleName: any = {plural: 'Áreas', single: 'Área'};

export const areasQuery: any = {
  "where":{
    "ativo":true,
    "nome":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"nome"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/shared/data.service.ts
 **/